import { Transform } from "class-transformer";
import { valueOrArrayToArrayOrUndefined } from "../../utils/valueOrArrayToArrayOrUndefined";
import { RetrieveTravelAgentsInput } from "@daytrip/api";
import { Direction } from "@daytrip/legacy-options";

export class RetrieveTravelAgentsInputConstructor implements RetrieveTravelAgentsInput {
    @Transform(({ value }) => valueOrArrayToArrayOrUndefined(value))
    hostAgencyIds?: string[] | undefined;

    sortBy?: any | undefined;

    @Transform(({ value }) => (value ? parseInt(value) : Direction.DESC))
    sortDirection?: Direction | undefined;

    @Transform(({ value }) => (value ? parseInt(value) : 1))
    skip?: number | undefined;

    @Transform(({ value }) => (value ? parseInt(value) : 10))
    limit?: number | undefined;
}
